import styled from "@emotion/styled";
import { type ReactNode } from "react";

import { Icon, IconButton } from "@skilitics/designer-ui-components";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  column-gap: 5px;
  color: ${({ theme }) => theme.generalTextIcon};
  max-width: 100%;
  min-width: 0;
`;

const Content = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

type BackgroundPropertiesRowProps = {
  onRemove: () => void;
  children?: ReactNode;
};

export const BackgroundPropertiesRow = ({ onRemove, children }: BackgroundPropertiesRowProps) => {
  return (
    <Row>
      <Content>{children}</Content>
      <IconButton onClick={onRemove} data-test="remove-background-property-button">
        <Icon icon="minus" size={14} />
      </IconButton>
    </Row>
  );
};
